import { render } from "./Waitlist.vue?vue&type=template&id=bf57b6ac"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"

import "./Waitlist.vue?vue&type=style&index=0&id=bf57b6ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__